import * as React from "react";
import { cn } from "@/lib/cn";

/** Simple initials avatar (no photo storage in this app) — deterministic
 * background color derived from the name so the same person always gets
 * the same color across the app. */
const PALETTE = [
  "bg-accent-100 text-accent-700",
  "bg-info-100 text-info-700",
  "bg-success-100 text-success-700",
  "bg-warning-100 text-warning-700",
  "bg-danger-100 text-danger-700",
];

function colorFor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export function Avatar({
  name,
  size = "md",
  className,
}: {
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");

  const sizeClass = { sm: "size-7 text-xs", md: "size-9 text-sm", lg: "size-12 text-base" }[size];

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-semibold",
        sizeClass,
        colorFor(name || "?"),
        className
      )}
    >
      {initials || "?"}
    </span>
  );
}
